import { Typography } from '@trellis/roots/typography'
import { AlertCircle } from 'lucide-react'

import { useEmailDivertNotice } from '@/hooks/useEmailDivertNotice'

export function EmailDivertNotice() {
  const message = useEmailDivertNotice()
  if (!message) return null

  return (
    <div className="flex gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3">
      <AlertCircle className="mt-0.5 size-4 shrink-0 text-amber-600" />
      <Typography variant="body-sm" className="text-amber-800">
        {message}
      </Typography>
    </div>
  )
}
